import axios from "axios";
const HOSTAPI = process.env.REACT_APP_BASE_URL;
const accessToken = sessionStorage.getItem('idToken');
export const CpeCreditData = async (data: any)  => {

    try {   
        const response = await axios.post(`${HOSTAPI}/events/cpe-credit`, data, {
            headers: {
            'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};